/**
 * POVPresetGrid - Grid of POV preset cards with radio button exclusivity
 *
 * Renders all 4 POV presets in a 2x2 grid (responsive).
 * Ensures only one preset can be selected at a time.
 */

import { POVPresetCard } from './POVPresetCard'
import { POV_PRESETS } from './constants'
import type { POVPresetGridProps } from './types'

export function POVPresetGrid({ selectedPOV, onSelectPOV }: POVPresetGridProps) {
  // Default to first preset if nothing selected
  const effectiveSelection = selectedPOV || POV_PRESETS[0].id

  return (
    <div
      data-testid="pov-preset-grid"
      data-tour="pov-presets"
      className="grid grid-cols-1 md:grid-cols-2 gap-4"
      role="radiogroup"
      aria-label="Point of View preset selection"
    >
      {POV_PRESETS.map((preset) => (
        <POVPresetCard
          key={preset.id}
          preset={preset}
          selected={effectiveSelection === preset.id}
          onSelect={onSelectPOV}
        />
      ))}
    </div>
  )
}
